if (!customElements.get('routine-slider-mto')) {
  customElements.define(
    'routine-slider-mto',
    class RoutineSliderMto extends HTMLElement {
      connectedCallback() {
        this.navItems = Array.from(this.querySelectorAll('.routine-slider-mto__nav-item'));
        this.slides = Array.from(
          this.querySelectorAll('.routine-slider-mto__media-item, .routine-slider-mto__panel')
        );
        this.navItems.forEach((item) =>
          item.addEventListener('click', () => this.setActive(item.dataset.index))
        );

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target);
            if (index > -1) this.setActive(event.target.dataset.index);
          });
        }
      }

      setActive(index) {
        this.slides.forEach((slide) => {
          const isTarget = slide.dataset.index === index;
          if (isTarget) {
            slide.classList.remove('is-leaving');
            slide.classList.add('is-active');
          } else if (slide.classList.contains('is-active')) {
            slide.classList.remove('is-active');
            slide.classList.add('is-leaving');
            // after sliding out to the left, jump back to the right edge without animating
            slide.addEventListener('transitionend', function handler(event) {
              if (event.target !== slide || event.propertyName !== 'transform') return;
              slide.removeEventListener('transitionend', handler);
              slide.style.transition = 'none';
              slide.classList.remove('is-leaving');
              slide.getBoundingClientRect();
              requestAnimationFrame(() => (slide.style.transition = ''));
            });
          }
        });

        this.navItems.forEach((item) => {
          const isTarget = item.dataset.index === index;
          item.classList.toggle('is-active', isTarget);
          item.setAttribute('aria-selected', isTarget);
        });
      }
    }
  );
}
